import { render } from "./ProductItemSV.vue?vue&type=template&id=00ac81be&scoped=true"
import script from "./ProductItemSV.vue?vue&type=script&lang=js"
export * from "./ProductItemSV.vue?vue&type=script&lang=js"

import "./ProductItemSV.vue?vue&type=style&index=0&id=00ac81be&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ac81be"]])

export default __exports__